<!--Loading Spinner  IsLoadingTask -->
<section *ngIf="IsLoadingTask">
    <div id="overlay" class="text-center">
        <div>
            <img [src]="loaderUrl">
            <!-- <p class="text-center">{{MainLoadingText}}</p> -->
        </div>
    </div>
</section>
<!--Loading Spinner  -->


<main>
<app-custom-header reloadEvent></app-custom-header>  
</main>